import ErrorManager from '@/common/utils/ErrorManager';
import { SuiviReclamation } from '@/models/SuiviReclamation';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree } from 'vuex';
import SuiviReclamationService, { FilterReclamations } from '../services/SuiviReclamationService';
import { SuiviReclamationActions, SuiviReclamationActionTypes } from './action-types';
import { SUIVI_RECLAMATION } from './mutation-types';
import { SuiviReclamationState } from './state';
import { HOME } from '@/modules/Home/store/mutation-types';

export const actions: ActionTree<SuiviReclamationState, RootState> = {
    async [SuiviReclamationActions.GET_SUIVI_RECLAMATION]({ commit }: SuiviReclamationActionTypes, payload: FilterReclamations) {
        commit(SUIVI_RECLAMATION.SET_ERROR, undefined);
        commit(SUIVI_RECLAMATION.SET_IS_LOADING, true);
        commit(SUIVI_RECLAMATION.SET_PAGE, payload.page);
        try {
            const response = await SuiviReclamationService.getSuiviReclamations(payload);
            if (response.status === 200 && response.data !== undefined) {
                if (payload.page === 0) {
                    commit(SUIVI_RECLAMATION.SET_ITEMS, response.data);
                    commit(SUIVI_RECLAMATION.SET_SCROLL, 0);
                    commit(SUIVI_RECLAMATION.SET_NB_OF_PAGES, response.headers.pages);
                    commit(SUIVI_RECLAMATION.SET_COUNT, response.headers.count);
                } else {
                    commit(SUIVI_RECLAMATION.ADD_ITEMS, response.data);
                }
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(SUIVI_RECLAMATION.SET_IS_LOADING, false);

        } catch (error) {
            commit(SUIVI_RECLAMATION.SET_IS_LOADING, false);
            commit(SUIVI_RECLAMATION.SET_ERROR, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },

    async [SuiviReclamationActions.GET_HISTORIQUE]({ commit }: SuiviReclamationActionTypes, reclamation: SuiviReclamation) {
        commit(SUIVI_RECLAMATION.SET_ERROR, undefined);
        try {
            const response = await SuiviReclamationService.getHistoriqueReclamation(reclamation.id);
            if (response.status === 200 && response.data !== undefined) {
                commit(SUIVI_RECLAMATION.SET_HISTORIQUE, response.data);
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
        } catch (error) {
            commit(SUIVI_RECLAMATION.SET_ERROR, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
    async [SuiviReclamationActions.GET_XLS_RECLAMATION]({ commit }: SuiviReclamationActionTypes, payload: FilterReclamations) {
        commit(SUIVI_RECLAMATION.SET_EXPORT_RECLAMATION_IS_LOADING, true);
        try {
            const response = await SuiviReclamationService.getExportXlsReclamations(payload);
            if (response.status === 200 && response.data !== undefined) {
                const blob = new Blob([response.data],{ type: response.headers['content-type'] });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'export_suivi_reclamation.xlsx';
                link.click();
                URL.revokeObjectURL(link.href);
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(SUIVI_RECLAMATION.SET_EXPORT_RECLAMATION_IS_LOADING, false);
        } catch (error) {
            commit(SUIVI_RECLAMATION.SET_EXPORT_RECLAMATION_IS_LOADING, false);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
    [SuiviReclamationActions.SET_RECLAMATIONS_CONSULTEES]({ commit }: SuiviReclamationActionTypes ): void {
        SuiviReclamationService.setReclamationsConsultees().then(() => {
            commit(HOME.SET_NB_NOUVELLES_RECLAMATIONS, 0);
        });
    },
};
